import React from "react";
import { InputNumber, message } from "antd";
import {NumberElementProps} from "@data-force/app";
import "../DynamicForm.scss";
import {connect} from "react-redux";
import {clearAlerts} from "../../../store/actions/layout";
import {ClearAlertsAction} from "../../../interfaces/store/actions/layout";

interface DispatchProps {
    clearAlerts(): ClearAlertsAction
}

export type Props = NumberElementProps & DispatchProps;

class NumberElement extends React.Component<Props> {
    constructor(props: Props) {
        super(props);
        this.inputChangeHandler = this.inputChangeHandler.bind(this);
    }

    inputChangeHandler(value: number): void {
        const {
            fieldName, index, refElements, onSave,
        }: Props = this.props;
        this.props.onChange({
            fieldName, value, index, refElements,
        });

        if (onSave) {
            onSave({
                fieldName,
                index,
                changeValue: value,
            });
        }
        message.destroy();
        this.props.clearAlerts();
    }

    render(): React.ReactElement {
        const {
            value, readOnly, className = "",
        }: NumberElementProps = this.props;

        return (
            <InputNumber
                className={className}
                value={value as number}
                onChange={this.inputChangeHandler}
                disabled={readOnly}
            />
        );
    }
}

const mapDispatchToProps: DispatchProps = {
    clearAlerts,
};

export default connect(null, mapDispatchToProps)(NumberElement);
